module.exports = "/_next/static/images/c4bfa2d0ccb77c8ef292abbcce3fbac1-card-lg@1x.jpg.webp";